var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(" "+_vm._s(_vm.$t('components.employees.employeeSalaries'))+" ")]),(_vm.$checkRole('employees_salaries_add'))?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/employeesSalaries/create?employee_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.customersInvoices.addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('employeesSalaries.SearchForASalary'),"emptyTableText":_vm.$t('employeesSalaries.ThereAreNoPaychecks'),"filter":{ employee_id: _vm.$route.params.id },"withoutCard":true,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        {
          column: 'code',
          title: _vm.$t('employeesSalaries.Salary'),
          type: 'mainLink',
          sort: true
        },
        {
          column: 'employee_id',
          title: _vm.$t('employeesSalaries.functionary'),
          type: 'link',
          to: 'employee',
          sort: true,
          link: true
        },
        {
          column: 'date',
          title: _vm.$t('employeesSalaries.date'),
          type: 'text',
          sort: true
        },
        {
          column: 'description',
          title: _vm.$t('employeesSalaries.thatsAbout'),
          type: 'text',
          sort: true
        },
        {
          column: 'notes',
          title: _vm.$t('employeesSalaries.note'),
          type: 'text',
          sort: true
        },
        {
          column: 'cost',
          title: _vm.$t('employeesSalaries.cost'),
          type: 'text',
          sort: true
        },

        {
          column: 'options',
          title: _vm.$t('employeesSalaries.Settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role: _vm.$checkRole('employees_salaries_edit')
            },
            { name: 'download', role: true },
            {
              name: 'delete',
              role: _vm.$checkRole('employees_salaries_delete')
            }
          ]
        }
      ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading')
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }